import {parseRawUrls} from '../common';

export default parseRawUrls({
  parrot: 'https://cultofthepartyparrot.com/parrots/hd/parrot.gif',
  opensourceparrot: 'https://cultofthepartyparrot.com/parrots/hd/opensourceparrot.gif',
  middleparrot: 'https://cultofthepartyparrot.com/parrots/hd/middleparrot.gif',
  rightparrot: 'https://cultofthepartyparrot.com/parrots/hd/rightparrot.gif',
  aussieparrot: 'https://cultofthepartyparrot.com/parrots/aussieparrot.gif',
  gothparrot: 'https://cultofthepartyparrot.com/parrots/gothparrot.gif',
  oldtimeyparrot: 'https://cultofthepartyparrot.com/parrots/oldtimeyparrot.gif',
  boredparrot: 'https://cultofthepartyparrot.com/parrots/boredparrot.gif',
  shuffleparrot: 'https://cultofthepartyparrot.com/parrots/hd/shuffleparrot.gif',
  shufflefurtherparrot: 'https://cultofthepartyparrot.com/parrots/shufflefurtherparrot.gif',
  congaparrot: 'https://cultofthepartyparrot.com/parrots/hd/congaparrot.gif',
  reversecongaparrot: 'https://cultofthepartyparrot.com/parrots/reversecongaparrot.gif',
  partyparrot: 'https://cultofthepartyparrot.com/parrots/hd/partyparrot.gif',
  sadparrot: 'https://cultofthepartyparrot.com/parrots/hd/sadparrot.gif',
  parrotcop: 'https://cultofthepartyparrot.com/parrots/parrotcop.gif',
  fastparrot: 'https://cultofthepartyparrot.com/parrots/hd/fastparrot.gif',
  ultrafastparrot: 'https://cultofthepartyparrot.com/parrots/hd/ultrafastparrot.gif',
  slowparrot: 'https://cultofthepartyparrot.com/parrots/slowparrot.gif',
  slomoparrot: 'https://cultofthepartyparrot.com/parrots/slomoparrot.gif',
  parrotdad: 'https://cultofthepartyparrot.com/parrots/parrotdad.gif',
  dealwithitparrot: 'https://cultofthepartyparrot.com/parrots/hd/dealwithitparrot.gif',
  fiestaparrot: 'https://cultofthepartyparrot.com/parrots/fiestaparrot.gif',
  pizzaparrot: 'https://cultofthepartyparrot.com/parrots/pizzaparrot.gif',
  hamburgerparrot: 'https://cultofthepartyparrot.com/parrots/hamburgerparrot.gif',
  bananaparrot: 'https://cultofthepartyparrot.com/parrots/bananaparrot.gif',
  chillparrot: 'https://cultofthepartyparrot.com/parrots/chillparrot.gif',
  explodyparrot: 'https://cultofthepartyparrot.com/parrots/explodyparrot.gif',
  shufflepartyparrot: 'https://cultofthepartyparrot.com/parrots/shufflepartyparrot.gif',
  'ice-cream-parrot': 'https://cultofthepartyparrot.com/parrots/ice-cream-parrot.gif',
  sassyparrot: 'https://cultofthepartyparrot.com/parrots/sassyparrot.gif',
  confusedparrot: 'https://cultofthepartyparrot.com/parrots/confusedparrot.gif',
  aussiecongaparrot: 'https://cultofthepartyparrot.com/parrots/aussiecongaparrot.gif',
  aussiereversecongaparrot: 'https://cultofthepartyparrot.com/parrots/aussiereversecongaparrot.gif',
  parrotwave1: 'https://cultofthepartyparrot.com/parrots/parrotwave1.gif',
  parrotwave2: 'https://cultofthepartyparrot.com/parrots/parrotwave2.gif',
  parrotwave3: 'https://cultofthepartyparrot.com/parrots/parrotwave3.gif',
  parrotwave4: 'https://cultofthepartyparrot.com/parrots/parrotwave4.gif',
  parrotwave5: 'https://cultofthepartyparrot.com/parrots/parrotwave5.gif',
  parrotwave6: 'https://cultofthepartyparrot.com/parrots/parrotwave6.gif',
  parrotwave7: 'https://cultofthepartyparrot.com/parrots/parrotwave7.gif',
  congapartyparrot: 'https://cultofthepartyparrot.com/parrots/hd/congapartyparrot.gif',
  moonwalkingparrot: 'https://cultofthepartyparrot.com/parrots/moonwalkingparrot.gif',
  thumbsupparrot: 'https://cultofthepartyparrot.com/parrots/thumbsupparrot.gif',
  coffeeparrot: 'https://cultofthepartyparrot.com/parrots/coffeeparrot.gif',
  parrotmustache: 'https://cultofthepartyparrot.com/parrots/hd/parrotmustache.gif',
  christmasparrot: 'https://cultofthepartyparrot.com/parrots/hd/christmasparrot.gif',
  parrotbeer: 'https://cultofthepartyparrot.com/parrots/parrotbeer.gif',
  darkbeerparrot: 'https://cultofthepartyparrot.com/parrots/darkbeerparrot.gif',
  blondesassyparrot: 'https://cultofthepartyparrot.com/parrots/blondesassyparrot.gif',
  bluescluesparrot: 'https://cultofthepartyparrot.com/parrots/bluescluesparrot.gif',
  gentlemanparrot: 'https://cultofthepartyparrot.com/parrots/hd/gentlemanparrot.gif',
  margaritaparrot: 'https://cultofthepartyparrot.com/parrots/margaritaparrot.gif',
  dreidelparrot: 'https://cultofthepartyparrot.com/parrots/dreidelparrot.gif',
  harrypotterparrot: 'https://cultofthepartyparrot.com/parrots/harrypotterparrot.gif',
  upvotepartyparrot: 'https://cultofthepartyparrot.com/parrots/upvotepartyparrot.gif',
  twinsparrot: 'https://cultofthepartyparrot.com/parrots/twinsparrot.gif',
  tripletsparrot: 'https://cultofthepartyparrot.com/parrots/tripletsparrot.gif',
  stableparrot: 'https://cultofthepartyparrot.com/parrots/stableparrot.gif',
  shipitparrot: 'https://cultofthepartyparrot.com/parrots/shipitparrot.gif',
  skiparrot: 'https://cultofthepartyparrot.com/parrots/skiparrot.gif',
  loveparrot: 'https://cultofthepartyparrot.com/parrots/loveparrot.gif',
  halalparrot: 'https://cultofthepartyparrot.com/parrots/halalparrot.gif',
  wendyparrot: 'https://cultofthepartyparrot.com/parrots/hd/wendyparrot.gif',
  popcornparrot: 'https://cultofthepartyparrot.com/parrots/hd/popcornparrot.gif',
  donutparrot: 'https://cultofthepartyparrot.com/parrots/hd/donutparrot.gif',
  evilparrot: 'https://cultofthepartyparrot.com/parrots/evilparrot.gif',
  discoparrot: 'https://cultofthepartyparrot.com/parrots/hd/discoparrot.gif',
  matrixparrot: 'https://cultofthepartyparrot.com/parrots/matrixparrot.gif',
  papalparrot: 'https://cultofthepartyparrot.com/parrots/papalparrot.gif',
  stalkerparrot: 'https://cultofthepartyparrot.com/parrots/stalkerparrot.gif',
  scienceparrot: 'https://cultofthepartyparrot.com/parrots/hd/scienceparrot.gif',
  prideparrot: 'https://cultofthepartyparrot.com/parrots/hd/prideparrot.gif',
  revolutionparrot: 'https://cultofthepartyparrot.com/parrots/hd/revolutionparrot.gif',
  fidgetparrot: 'https://cultofthepartyparrot.com/parrots/fidgetparrot.gif',
  beretparrot: 'https://cultofthepartyparrot.com/parrots/hd/beretparrot.gif',
  tacoparrot: 'https://cultofthepartyparrot.com/parrots/tacoparrot.gif',
  ryangoslingparrot: 'https://cultofthepartyparrot.com/parrots/ryangoslingparrot.gif',
  luckyparrot: 'https://cultofthepartyparrot.com/parrots/luckyparrot.gif',
  birthdaypartyparrot: 'https://cultofthepartyparrot.com/parrots/hd/birthdaypartyparrot.gif',
  jediparrot: 'https://cultofthepartyparrot.com/parrots/hd/jediparrot.gif',
  sithparrot: 'https://cultofthepartyparrot.com/parrots/hd/sithparrot.gif',
  angryparrot: 'https://cultofthepartyparrot.com/parrots/angryparrot.gif',
  invisibleparrot: 'https://cultofthepartyparrot.com/parrots/invisibleparrot.gif',
  rotatingparrot: 'https://cultofthepartyparrot.com/parrots/rotatingparrot.gif',
  cryptoparrot: 'https://cultofthepartyparrot.com/parrots/cryptoparrot.gif',
  sushiparrot: 'https://cultofthepartyparrot.com/parrots/hd/sushiparrot.gif',
  pumpkinparrot: 'https://cultofthepartyparrot.com/parrots/hd/pumpkinparrot.gif',
  angelparrot: 'https://cultofthepartyparrot.com/parrots/hd/angelparrot.gif',
  bluntparrot: 'https://cultofthepartyparrot.com/parrots/hd/bluntparrot.gif',
  sintparrot: 'https://cultofthepartyparrot.com/parrots/hd/sintparrot.gif',
  pirateparrot: 'https://cultofthepartyparrot.com/parrots/hd/pirateparrot.gif',
  ceilingparrot: 'https://cultofthepartyparrot.com/parrots/hd/ceilingparrot.gif',
  mardigrasparrot: 'https://cultofthepartyparrot.com/parrots/hd/mardigrasparrot.gif',
  sovjetparrot: 'https://cultofthepartyparrot.com/parrots/sovjetparrot.gif',
  portalparrot: 'https://cultofthepartyparrot.com/parrots/portalparrot.gif',
  hardhatparrot: 'https://cultofthepartyparrot.com/parrots/hd/hardhatparrot.gif',
  flyingmoneyparrot: 'https://cultofthepartyparrot.com/parrots/hd/flyingmoneyparrot.gif',
  portalorangeparrot: 'https://cultofthepartyparrot.com/parrots/portalorangeparrot.gif',
  portalblueparrot: 'https://cultofthepartyparrot.com/parrots/portalblueparrot.gif',
  bunnyparrot: 'https://cultofthepartyparrot.com/parrots/hd/bunnyparrot.gif',
  norwegianblueparrot: 'https://cultofthepartyparrot.com/parrots/hd/norwegianblueparrot.gif',
  transparront: 'https://cultofthepartyparrot.com/parrots/hd/transparront.gif',
  fixparrot: 'https://cultofthepartyparrot.com/parrots/fixparrot.gif',
  brazilianplayerparrot: 'https://cultofthepartyparrot.com/parrots/brazilianplayerparrot.gif',
  brazilianfanparrot: 'https://cultofthepartyparrot.com/parrots/brazilianfanparrot.gif',
  marshmallowparrot: 'https://cultofthepartyparrot.com/parrots/hd/marshmallowparrot.gif',
  whitewalkerparrot: 'https://cultofthepartyparrot.com/parrots/hd/whitewalkerparrot.gif',
  'trans-parrot': 'https://cultofthepartyparrot.com/parrots/hd/trans-parrot.gif',
  calvinist_parrot: 'https://cultofthepartyparrot.com/parrots/hd/calvinist_parrot.gif',
});
